//@ts-nocheck
import React, { useState, useEffect } from 'react'
import { NavLink } from 'react-router-dom'
import { keyGenerator } from '../../../helpers/helpers'
import styles from './mobileNavItem.module.scss'

const MobileNavItem = ({
  mainName = 'Main',
  mainRout = '/',
  items = null,
  iconFont = 'fas fa-book',
  onClick,
}) => {
  return (
    <div className={styles.container}>
      <NavLink
        onClick={onClick}
        activeClassName={styles.activeNav}
        to={mainRout}
        className={styles.mainContainer}
      >
        <i className={iconFont}></i>
        <div>{mainName}</div>
      </NavLink>
      <div className={styles.itemsContainer}>
        {items &&
          items.length > 0 &&
          items.map((nav, i) => (
            <NavLink
              onClick={onClick}
              activeClassName={styles.activeNav}
              key={`nav${nav.to}${nav.name}${i}s`}
              to={`/books/categories${nav.to}`}
            >
              <i
                aactiveclassname={styles.iActive}
                className={`${styles.icon} fas fa-arrow-right`}
              ></i>
              {nav.name}
            </NavLink>
          ))}
      </div>
    </div>
  )
}

export default MobileNavItem
